import React from 'react';
import { Text } from './Text';

const rowStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
};

const labelStyle: React.CSSProperties = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flexShrink: 0,
  marginRight: '8px',
  textAlign: 'left'
};

const valueStyle: React.CSSProperties = {
  textAlign: 'right',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flex: 1
};

interface InfoRowProps {
  label: string | React.ReactNode;
  value: string | React.ReactNode;
}

export function InfoRow({ label, value }: InfoRowProps) {
  return (
    <div style={rowStyle}>
      <Text variant='body2' style={labelStyle}>
        {label}
      </Text>
      <Text variant='body2-medium' style={valueStyle}>
        {value}
      </Text>
    </div>
  );
}
